/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  DAppAddressRelay,
  DAppAddressRelayInterface,
} from "../../../contracts/relays/DAppAddressRelay";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IInputBox",
        name: "_inputBox",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "getInputBox",
    outputs: [
      {
        internalType: "contract IInputBox",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_dapp",
        type: "address",
      },
    ],
    name: "relayDAppAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "0x60a060405234801561001057600080fd5b506040516102bc3803806102bc83398101604081905261002f91610040565b6001600160a01b0316608052610070565b60006020828403121561005257600080fd5b81516001600160a01b038116811461006957600080fd5b9392505050565b60805161022c61009060003960008181603c015260c8015261022c6000f3fe608060405234801561001057600080fd5b50600436106100355760003560e01c8062aace9a1461003a5780633016f49e14610077575b600080fd5b7f00000000000000000000000000000000000000000000000000000000000000006040516001600160a01b03909116815260200160405180910390f35b61008a61008536600461014f565b61008c565b005b60408051606083901b6bffffffffffffffffffffffff19166020820152815180820360140181526034820192839052631789cd6360e01b9092527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031690631789cd6390610107908590859060380161017f565b6020604051808303816000875af1158015610126573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061014a91906101dd565b505050565b60006020828403121561016157600080fd5b81356001600160a01b038116811461017857600080fd5b9392505050565b60018060a01b038316815260006020604081840152835180604085015260005b818110156101bb5785810183015185820160600152820161019f565b506000606082860101526060601f19601f830116850101925050509392505050565b6000602082840312156101ef57600080fd5b505191905056fea264697066735822122069e730f7a2a395fe8a69c595a0c196f1b1dfb520ea883a704bd8cac077623cce64736f6c63430008130033";

type DAppAddressRelayConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: DAppAddressRelayConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class DAppAddressRelay__factory extends ContractFactory {
  constructor(...args: DAppAddressRelayConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _inputBox: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<DAppAddressRelay> {
    return super.deploy(
      _inputBox,
      overrides || {}
    ) as Promise<DAppAddressRelay>;
  }
  override getDeployTransaction(
    _inputBox: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_inputBox, overrides || {});
  }
  override attach(address: string): DAppAddressRelay {
    return super.attach(address) as DAppAddressRelay;
  }
  override connect(signer: Signer): DAppAddressRelay__factory {
    return super.connect(signer) as DAppAddressRelay__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DAppAddressRelayInterface {
    return new utils.Interface(_abi) as DAppAddressRelayInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DAppAddressRelay {
    return new Contract(address, _abi, signerOrProvider) as DAppAddressRelay;
  }
}
